import React, { useEffect, useRef, useState } from 'react';
import './ChoosingComponent.scss';

const REASONS = [
  'Easy to use — no tech skills needed',
  'Beautiful, customizable website for your guests',
  'Real-time updates and analytics',
  'Professional support every step of the way',
];

const ChoosingComponent = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Reveal-on-scroll
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.25 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`choose ${visible ? 'is-visible' : ''}`}
      id="choose"
      aria-label="Why Choose Plan My Guest?"
    >
      <div className="choose__grid">
        {/* Left: heading + emotional line */}
        <div className="choose__lead">
          <p className="choose__eyebrow">Why Choose</p>
          <h2 className="choose__title">Plan My Guest?</h2>

          {/* <p className="choose__intro">
            Show why you’re different. Here are a few strong points couples love.
          </p> */}

          <blockquote className="choose__quote">
            “Plan My Guest is here to make your journey from ‘Yes’ to ‘I do’ as smooth
            and stress-free as possible.”
          </blockquote>
        </div>

        {/* Right: reasons rail */}
        <ol className="choose__rail">
          {REASONS.map((text, i) => (
            <li className="choose__item" key={i}>
              <div className="choose__badge" aria-hidden="true">{i + 1}</div>
              <h3 className="choose__reason">{text}</h3>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default ChoosingComponent;
